import styled from "styled-components";

import DsButton from "ds/Button";

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 1fr 24px;
  align-items: center;
  gap: 16px;

  padding: 12px 40px;

  font-weight: 600;
  font-size: 14px;

  background: #0c0f10;
  color: var(--snow);
`;

export const BannerContent = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
`;

export const Button = styled(DsButton)`
  flex-shrink: 0;
`;

export const CloseWrapper = styled.div`
  height: 24px;
`;
